import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { CategoryClippingControllerService } from './api/categoryClippingController.service';
import { ClientArchiveRequestControllerService } from './api/clientArchiveRequestController.service';
import { ClientAnalyticsControllerService } from './api/clientAnalyticsController.service';
import { ClientAuthorControllerService } from './api/clientAuthorController.service';
import { ClientCategoryControllerService } from './api/clientCategoryController.service';
import { ClientClipControllerService } from './api/clientClipController.service';
import { ClientMediumControllerService } from './api/clientMediumController.service';
import { ClientSentimentControllerService } from './api/clientSentimentController.service';
import { ManagementAuthorControllerService } from './api/managementAuthorController.service';
import { ManagementCategoryClippingControllerService } from './api/managementCategoryClippingController.service';
import { ManagementClipControllerService } from './api/managementClipController.service';
import { ManagementClipReportControllerService } from './api/managementClipReportController.service';
import { ManagementKeywordControllerService } from './api/managementKeywordController.service';
import { ManagementMediumClippingControllerService } from './api/managementMediumClippingController.service';
import { ManagementRecordingScheduleControllerService } from './api/managementRecordingScheduleController.service';
import { ManagementRecordingSettingsControllerService } from './api/managementRecordingSettingsController.service';
import { ManagementScreenshotControllerService } from './api/managementScreenshotController.service';
import { ManagementSentimentControllerService } from './api/managementSentimentController.service';
import { ManagementTagClippingControllerService } from './api/managementTagClippingController.service';
import { ManagementTranscriptionControllerService } from './api/managementTranscriptionController.service';
import { ManagementUploadControllerService } from './api/managementUploadController.service';
import { TagClippingControllerService } from './api/tagClippingController.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    CategoryClippingControllerService,
    ClientArchiveRequestControllerService,
    ClientAnalyticsControllerService,
    ClientAuthorControllerService,
    ClientCategoryControllerService,
    ClientClipControllerService,
    ClientMediumControllerService,
    ClientSentimentControllerService,
    ManagementAuthorControllerService,
    ManagementCategoryClippingControllerService,
    ManagementClipControllerService,
    ManagementClipReportControllerService,
    ManagementKeywordControllerService,
    ManagementMediumClippingControllerService,
    ManagementRecordingScheduleControllerService,
    ManagementRecordingSettingsControllerService,
    ManagementScreenshotControllerService,
    ManagementSentimentControllerService,
    ManagementTagClippingControllerService,
    ManagementTranscriptionControllerService,
    ManagementUploadControllerService,
    TagClippingControllerService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<any> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
